import MkuButton from './src/button';

MkuButton.install = function (Vue) {
  Vue.component(MkuButton.name, MkuButton);
};

export default MkuButton;
